import React, { useState } from 'react';
import { Box, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import TestOption from '../compnents/TestOption';
import FileUploader from '@jumbo/Dashboards/Media/FileUploader';
import TestTitle from '../compnents/TestTitle';
import ImagePicker from '../compnents/ImagePicker';
import ConnectingElementCreator from '../compnents/ConnectingElementCreator';
import ConnectingListElement from '../compnents/ConnectingListElement';

const useStyles = makeStyles(theme => ({
  cardContainer: {
    marginTop: 10,
  },
  answerSelctText: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
  itemContainer: {
    width: '100%',
    borderWidth: 2,
    borderColor: theme.palette.grey[400],
    borderStyle: 'dashed',
    borderRadius: '10px',
    padding: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  NoItemText: {
    color: theme.palette.grey[400],
    fontSize: 14,
  },
}));

const ConnectingQuestionElement = ({
  questoinTitle,
  setQuestoinTitle,
  cover,
  setCover,
  score,
  setScore,
  rightSideItems,
  setRightSideItems,
  leftSideItems,
  setLeftSideItems,
}) => {
  const classes = useStyles();
  const [openFileUploader, setOpenFileUploader] = useState(false);

  const [rightSideVal, setRightSideVal] = useState('');
  const [leftSideVal, setLeftSideVal] = useState('');

  const handleAddRightSide = () => {
    if (rightSideVal) {
      const rightItems = [...rightSideItems];
      rightItems.push(rightSideVal);
      setRightSideItems(rightItems);
      setRightSideVal('');
    }
  };
  const handleAddLeftSide = () => {
    if (leftSideVal) {
      const leftItems = [...leftSideItems];
      leftItems.push(leftSideVal);
      setLeftSideItems(leftItems);
      setLeftSideVal('');
    }
  };

  const handleEditRightItem = (value, index) => {
    let rightItems = [...rightSideItems];
    rightItems[index] = value;
    setRightSideItems(rightItems);
  };

  const handleRemoveRightItem = Itemindex => {
    let rightItems = [...rightSideItems];
    rightItems = rightItems.filter((item, index) => {
      return index !== Itemindex;
    });
    setRightSideItems(rightItems);
  };

  const handleRemoveLeftItem = Itemindex => {
    let leftItems = [...leftSideItems];
    leftItems = leftItems.filter((item, index) => {
      return index !== Itemindex;
    });
    setLeftSideItems(leftItems);
  };

  const handleEditLeftItem = (value, index) => {
    let leftItems = [...leftSideItems];
    leftItems[index] = value;
    setLeftSideItems(leftItems);
  };

  return (
    <React.Fragment>
      <TestTitle value={questoinTitle} handeChange={value => setQuestoinTitle(value)} />
      <Grid item xs={12}>
        <Typography className={classes.answerSelctText}>انتخاب تصویر سوال</Typography>
        <ImagePicker
          cover={cover}
          handlePick={() => setOpenFileUploader(true)}
          handleRevome={() => setCover('')}
          previewStyles={{ marginInline: 'auto', marginBlock: '20px' }}
          placeHolderStyles={{ marginInline: 'auto', marginBlock: '20px' }}
        />
      </Grid>
      <ConnectingElementCreator
        title={'موارد سمت راست'}
        value={rightSideVal}
        handleClick={handleAddRightSide}
        handleChange={value => setRightSideVal(value)}
      />
      <ConnectingElementCreator
        title={'موارد سمت چپ'}
        value={leftSideVal}
        handleClick={handleAddLeftSide}
        handleChange={value => setLeftSideVal(value)}
      />
      <Grid item xs={12} md={6}>
        <Box className={classes.itemContainer}>
          {rightSideItems.length !== 0 ? (
            rightSideItems.map((item, index) => (
              <ConnectingListElement
                key={index}
                value={item}
                handleChange={val => handleEditRightItem(val, index)}
                handleRemove={() => handleRemoveRightItem(index)}
              />
            ))
          ) : (
            <Typography className={classes.NoItemText}>موردی برای نمایش وجود ندارد</Typography>
          )}
        </Box>
      </Grid>
      <Grid item xs={12} md={6}>
        <Box className={classes.itemContainer}>
          {leftSideItems.length !== 0 ? (
            leftSideItems.map((item, index) => (
              <ConnectingListElement
                key={index}
                value={item}
                handleChange={val => handleEditLeftItem(val, index)}
                handleRemove={() => handleRemoveLeftItem(index)}
              />
            ))
          ) : (
            <Typography className={classes.NoItemText}>موردی برای نمایش وجود ندارد</Typography>
          )}
        </Box>
      </Grid>

      <TestOption text={''} title={'پله'} type={'number'} value={score} handleChange={value => setScore(+value)} />
      <FileUploader
        selectMode
        open={openFileUploader}
        handleClose={() => setOpenFileUploader(false)}
        handleSelect={selected => setCover(selected)}
        selectedItem={cover}
        imageSelector={true}
      />
    </React.Fragment>
  );
};

export default ConnectingQuestionElement;
